import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/calculators/destiny-matrix/sum.webp'


const _hoisted_1 = { class: "grid grid-cols-[repeat(4,max-content)] grid-rows-2 items-center gap-1 pt-2" }


import CircleComponent from "@/views/Calculators/DestinyMatrix/components/CircleComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SummarizeComponent',
  props: {
    firstLabel: {},
    secondLabel: {},
    firstValue: {},
    secondValue: {},
    sumValue: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(__props.firstLabel), 1),
    _createVNode(CircleComponent, { value: __props.firstValue }, null, 8, ["value"]),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_0,
      class: "row-span-2",
      alt: "sum"
    }, null, -1)),
    _createVNode(CircleComponent, {
      class: "row-span-2",
      value: __props.sumValue
    }, null, 8, ["value"]),
    _createElementVNode("p", null, _toDisplayString(__props.secondLabel), 1),
    _createVNode(CircleComponent, {
      value: __props.secondValue,
      class: "justify-self-center"
    }, null, 8, ["value"])
  ]))
}
}

})